import { Component, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatDialogActions, MatDialogContent, MatDialogRef } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-forecast-details-modal',
  imports: [TranslatePipe, MatIcon, MatIconButton, MatDialogContent, MatDialogActions, MatButton],
  templateUrl: './forecast-details-modal.component.html',
  styleUrl: './forecast-details-modal.component.scss'
})
export class ForecastDetailsModalComponent {
  readonly dialogRef = inject(MatDialogRef<ForecastDetailsModalComponent>);

  protected closeModal() {
    this.dialogRef.close({ continue: false });
  }
}
